import React, { useContext } from "react";

import UserContext from "../context/user-context";
import LogInForm from "./../components/login-form";

import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <>
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "8px",
          margin: "3em",
          padding: "3em",
        }}
      >
        <h1>Version 1.2.1 Example Block Pages</h1>
        <div>
          <ul>
            <li>
              <Link to="/webnotifications/block-page.jsp?url=https://www.hulu.com&referer=&reason=Not+allowed+to+browse+Gambling+category&reasoncode=CATEGORY_DENIED&timebound=1&action=deny&kind=category&rule=322760&cat=Gambling&user=user@domain.tld&locid=00000000&lang=fr_FR&zsq=JDspV0Ft81ZLq0j55Z0FsFsL6n0VSDV0F86pDD6zsq">
                Blocked Content (POLICY_DENIED)
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/block-page.jsp?url=https://www.hulu.com&referer=&reason=Not+allowed+to+browse+Gambling+category&reasoncode=GEOIP_DENIED&timebound=1&action=deny&kind=category&rule=322760&cat=Gambling&user=user@domain.tld&locid=00000000&lang=fr_FR&zsq=JDspV0Ft81ZLq0j55Z0FsFsL6n0VSDV0F86pDD6zsq">
                Blocked Content (GEOIP_DENIED)
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/block-page.jsp?url=https://www.hulu.com&referer=&reason=Not+allowed+to+browse+Gambling+category&reasoncode=TCP_ERROR&timebound=1&action=deny&kind=category&rule=322760&cat=Gambling&user=user@domain.tld&locid=00000000&lang=fr_FR&zsq=JDspV0Ft81ZLq0j55Z0FsFsL6n0VSDV0F86pDD6zsq">
                Blocked Content (TCP_ERROR)
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/coach.jsp?url=https://www.airtime.com&referer=&reason=Not+allowed+to+browse+Gambling+category&reasoncode=CATEGORY_DENIED&timebound=1&action=deny&kind=category&rule=322760&cat=Gambling&user=user@domain.tld&locid=00000000&lang=fr_FR&zsq=JDspV0Ft81ZLq0j55Z0FsFsL6n0VSDV0F86pDD6zsq">
                Future Blocked Content
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/coach-lite.jsp?url=https://www.craigslist.org&referer=&reason=Not+allowed+to+browse+Gambling+category&reasoncode=CATEGORY_DENIED&timebound=1&action=deny&kind=category&rule=322760&cat=Gambling&user=user@domain.tld&locid=00000000&lang=fr_FR&zsq=JDspV0Ft81ZLq0j55Z0FsFsL6n0VSDV0F86pDD6zsq">
                External Content
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/coach.jsp?url=https://openai.com/chatgpt/overview/&referer=https://www.google.com/&reason=Request+method+cautioned+for+category+Generative+AI+and+ML+Applications&reasoncode=METHOD_CAUTIONED&timebound=1&action=deny&kind=category&rule=367126&cat=Generative+AI+and+ML+Applications&locid=00000000&user=user@domain.tld&lang=en_US&zsq=QvJQj5Qqv4tZswZrM3jRnsZDvMwPtHj5QDDjJHHzsq">
                Generative AI and ML Applications (Block by the end of month)
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/block-page.jsp?url=https://chatgpt.com/?utm-source=google&utm-medium=paidsearch-brand&utm-campaign=DEPT-SEM-Google-Brand-Acquisition-NAMER-US-Consumer-CPA-BAU-Mix&utm-term=chatgpt&gad-source=1&gad-campaignid=21714513245&gbraid=0AAAAA%2dIW%2dUWq6QRSK8fpj3vdm9MWOAzHk&gclid=EAIaIQobChMI-qWu5IzMjQMVCDIIBR0F4y4NEAAYASAAEgIp%2dPD-BwE&referer=https://www.google.com/&reason=Request method cautioned for category Generative AI and ML Applications&reasoncode=METHOD_CAUTIONED&timebound=1&action=deny&kind=category&rule=1454140&cat=Generative AI and ML Applications&user=user@domain.tld&locid=00000000&lang=en_US&zsq=Q6RJjJVkTrv6vSW1WPRT5S5JnVSPk85JT73Mr2jzsq">
                Generative AI and ML Applications (Block forever)
              </Link>
            </li>
            <li>
              <Link to="/webnotifications/blockoe-page.jsp?url=https%3a%2f%2fwww%2eopenevidence%2ecom%2f&referer=https%3a%2f%2fwww%2ebing%2ecom%2f&reason=Not+allowed+to+browse+Generative+AI+and+ML+Applications+category&reasoncode=CATEGORY_DENIED&timebound=1&action=deny&kind=category&rule=264206&cat=Generative+AI+and+ML+Applications&user=user@domain.tld&locid=00000000&lang=en_US&zsq=6SjsMZF4Hks0j8MmF8WlP0V4mD8SrPMZLJRFnlDzsq">
                Open Evidence (Block forever)
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default HomePage;
